import { useTranslation } from 'react-i18next';
import { extractFirstName } from '@/utils/personName';

export function OnboardingHeading({ fullName }: { fullName: string }) {
  const { t } = useTranslation('clients');
  return (
    <div className="mb-6">
      <h1 className="text-2xl font-bold text-zooindigo">
        {t('portal.greeting', { name: extractFirstName(fullName) })}
      </h1>
      <p className="text-sm text-zoomuted mt-1">{t('portal.consentGate.onboardingIntro')}</p>
    </div>
  );
}
